import "core-js";
import "isomorphic-fetch";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { params, Context } from "./context";
import App from "./App";

const appConfig = {
	context: params.context,
	theme: params.theme,
	groupName: params.groupName,
	groupId: params.groupId,
};

ReactDOM.render(
	<App {...appConfig} />,
	document.getElementsByClassName("study-recommendation-mount-point")[0]
);
